import "./eventsTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const EventsTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Events
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true); // Start loading
        const res = await axios.get(
          `${BASE_URL}/api/events/findAllEvent/${userId}`,
        );
        setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchEvents();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/events/deleteEvent/${id}`,
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = (eventData) => {
    navigate("/events/newEvents", { state: { event: eventData } });
  };

  const eventListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "eventName",
      headerName: "Event Name",
      width: 230,
      renderCell: (params) => (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={params.row.eventImages?.[0]?.url}
            alt="avatar"
          />
          {params.row.eventName}
        </div>
      ),
    },
    { field: "eventOrganizerPhone", headerName: "Organizer Phone", width: 150 },
    { field: "createdDate", headerName: "Created Date", width: 110 },
    { field: "eventDate", headerName: "Event Date", width: 110 },
    { field: "eventTime", headerName: "Event Time", width: 100 },
    { field: "eventAddress", headerName: "Address", width: 200 },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <IconButton color="primary">
            <Link to="/events/newEvents">
              <Add />
            </Link>
          </IconButton>
          <IconButton onClick={() => handleUpdate(params.row)} color="primary">
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => {
              setSelectedEvent(params.row);
              setOpenDialog(true);
            }}
            color="error"
          >
            <Delete />
          </IconButton>
        </div>
      ),
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedEvent) {
      await handleDelete(selectedEvent._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Events
        </Typography>
        <Link to="/events/newEvents">
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 25 }}
          >
            Add Event
          </Button>
        </Link>
      </div>

      <Grid container justifyContent="center">
        {loading ? ( // Show loader when fetching data
          <CircularProgress />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={eventListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}

        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this Event?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
};

export default EventsTable;
